import { Box, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { BKVCrossIcon, BKVRightIcon } from "./Icons";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import xmark from "../icons/xmark-circle.svg";
import tickMark from "../icons/check-circle-outline.svg";
import { Link } from "@mui/material";
import constants from "src/constants";
import { makeStyles } from "@material-ui/core";
import { Utils } from "src/utils/Utils";
import { useDispatch, useSelector } from "src/store";
import { useCookies } from "react-cookie";
import Title from "./Title";
import SubText from "./SubText";

const PlanComparision = ({ content }) => {
  const theme = useTheme();
  const classes = useStyles();
  const state = useSelector((state) => state.bkv);
  const [cookies] = useCookies();

  const Button = styled(MuiButton)((props) => ({
    borderRadius: "10vw",
    background: theme.palette.mustard.main,
    whiteSpace: "nowrap",
  }));

  return (
    <Box
      // width="100%"
      sx={{
        // padding: "0 5% 0 5%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "22%",
        flexDirection: "column",
      }}
    >
      <Title text={content?.details?.subtitle} />
      <SubText text={content?.details?.title} />
      <Box
        sx={{
          height: "30vw",
          width: "90%",
          borderRadius: "2vw",
          diaply: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
          marginTop: { xs: "5%", sm: "5%", md: "5%", lg: "0%" },
        }}
      >
        <Box
          width="100%"
          sx={{
            height: "10%",
            borderRadius: "2vw 2vw 0 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            marginBottom: "-1px",
          }}
        >
          <Box width="calc(100% / 3)" height="100%"></Box>
          <Box
            width="calc(100% / 3)"
            height="100%"
            sx={{
              borderRadius: "2vw 2vw 0 0",
              background: "#009A88",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              fontSize={{
                xs: "9.5px",
                md: "1.5vw",
                lg: "30px",
              }}
              sx={{ color: "#fff" }}
              variant="body2"
            >
              Bluebonnet
            </Typography>
          </Box>
          <Box
            width="calc(100% / 3)"
            height="100%"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              fontSize={{
                xs: "9.5px",
                md: "1.5vw",
                lg: "30px",
              }}
            >
              Your Plan
            </Typography>
          </Box>
        </Box>

        <Box
          height="100%"
          sx={{
            border: `1px ${theme.palette.secondary.light} solid`,
            borderRadius: "2vw",
          }}
        >
          <Box
            width="100%"
            sx={{
              height: "calc(100% / 6)",
              borderRadius: "2vw 2vw 0 0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                borderRadius: "2vw 0 0 0",
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                fontSize={{
                  xs: "9.5px",
                  md: "1.5vw",
                  lg: "20px",
                }}
                sx={{ marginLeft: "5%" }}
              >
                Low Fixed Rate
              </Typography>
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                background: "#009A88",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img width="8%" src={tickMark} />
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "0 2vw 0 0",
              }}
            >
              <Typography
                sx={{ color: "#f22824" }}
                fontSize={{
                  xs: "2.5vw",
                  sm: "2.5vw",
                  md: "1.5vw",
                  lg: "1.5vw",
                }}
                variant="body2"
              >
                ?
              </Typography>
            </Box>
          </Box>
          <Box
            width="100%"
            sx={{
              height: "calc(100% / 6)",
              borderRadius: "2vw 2vw 0 0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                borderRight: "none",
                background: theme.palette.secondary.light,
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                fontSize={{
                  xs: "9.5px",
                  md: "1.5vw",
                  lg: "20px",
                }}
                sx={{ marginLeft: "5%" }}
              >
                ElectroShare Rewards
              </Typography>
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                background: "#009A88",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTop: `1px ${theme.palette.secondary.light} solid`,
              }}
            >
              <img width="8%" src={tickMark} />
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: theme.palette.secondary.light,
              }}
            >
              <Typography
                sx={{ color: "#f22824" }}
                fontSize={{
                  xs: "2.5vw",
                  sm: "2.5vw",
                  md: "1.5vw",
                  lg: "1.5vw",
                }}
                variant="body2"
              >
                ?
              </Typography>
            </Box>
          </Box>
          <Box
            width="100%"
            sx={{
              height: "calc(100% / 6)",
              borderRadius: "2vw 2vw 0 0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                borderRight: "none",
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                fontSize={{
                  xs: "9.5px",
                  md: "1.5vw",
                  lg: "20px",
                }}
                sx={{ marginLeft: "5%" }}
              >
                Blend & Extend
              </Typography>
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                background: "#009A88",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTop: `1px ${theme.palette.secondary.light} solid`,
              }}
            >
              <img width="8%" src={tickMark} />
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ color: "#f22824" }}
                fontSize={{
                  xs: "2.5vw",
                  sm: "2.5vw",
                  md: "1.5vw",
                  lg: "1.5vw",
                }}
                variant="body2"
              >
                ?
              </Typography>
            </Box>
          </Box>
          <Box
            width="100%"
            sx={{
              height: "calc(100% / 6)",
              borderRadius: "2vw 2vw 0 0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                borderRight: "none",
                background: theme.palette.secondary.light,
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                fontSize={{
                  xs: "9.5px",
                  md: "1.5vw",
                  lg: "20px",
                }}
                sx={{ marginLeft: "5%" }}
              >
                Save Now, Pay Later
              </Typography>
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                background: "#009A88",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTop: `1px ${theme.palette.secondary.light} solid`,
              }}
            >
              <img width="8%" src={tickMark} />
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: theme.palette.secondary.light,
              }}
            >
              <Typography
                sx={{ color: "#f22824" }}
                fontSize={{
                  xs: "2.5vw",
                  sm: "2.5vw",
                  md: "1.5vw",
                  lg: "1.5vw",
                }}
                variant="body2"
              >
                ?
              </Typography>
            </Box>
          </Box>
          <Box
            width="100%"
            sx={{
              height: "calc(100% / 6)",
              borderRadius: "2vw 2vw 0 0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                borderRight: "none",
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                fontSize={{
                  xs: "9.5px",
                  md: "1.5vw",
                  lg: "20px",
                }}
                sx={{ marginLeft: "5%" }}
              >
                Spark Alerts
              </Typography>
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                background: "#009A88",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTop: `1px ${theme.palette.secondary.light} solid`,
              }}
            >
              <img width="8%" src={tickMark} />
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ color: "#f22824" }}
                fontSize={{
                  xs: "2.5vw",
                  sm: "2.5vw",
                  md: "1.5vw",
                  lg: "1.5vw",
                }}
                variant="body2"
              >
                ?
              </Typography>
            </Box>
          </Box>
          <Box
            width="100%"
            sx={{
              height: "calc(100% / 6)",
              borderRadius: "2vw 2vw 0 0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                borderRight: "none",
                borderRadius: "0 0 0 2vw",
                background: theme.palette.secondary.light,
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                fontSize={{
                  xs: "9.5px",
                  md: "1.5vw",
                  lg: "20px",
                }}
                sx={{ marginLeft: "5%" }}
              >
                Contract Consultation
              </Typography>
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                background: "#009A88",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTop: `1px ${theme.palette.secondary.light} solid`,
              }}
            >
              <img width="8%" src={tickMark} />
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "0 0 2vw 0",
                background: theme.palette.secondary.light,
              }}
            >
              <Typography
                sx={{ color: "#f22824" }}
                fontSize={{
                  xs: "2.5vw",
                  sm: "2.5vw",
                  md: "1.5vw",
                  lg: "1.5vw",
                }}
                variant="body2"
              >
                ?
              </Typography>
            </Box>
          </Box>
          {/* <Box
            width="100%"
            sx={{
              height: "calc(100% / 6)",
              borderRadius: "2vw 2vw 0 0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                borderRight: "none",
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                fontSize={{
                  xs: "9.5px",
                  md: "1.5vw",
                  lg: "20px",
                }}
                sx={{ marginLeft: "5%" }}
              >
                Best Practices{" "}
              </Typography>
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                background: "#009A88",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTop: `1px ${theme.palette.secondary.light} solid`,
              }}
            >
              <img width="8%" src={tickMark} />
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ color: "#f22824" }}
                fontSize={{
                  xs: "2.5vw",
                  sm: "2.5vw",
                  md: "1.5vw",
                  lg: "1.5vw",
                }}
                variant="body2"
              >
                ?
              </Typography>
            </Box>
          </Box> */}
          {/* <Box
            width="100%"
            sx={{
              height: "calc(100% / 6)",
              borderRadius: "2vw 2vw 0 0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                borderRight: "none",
                background: theme.palette.secondary.light,
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                fontSize={{
                  xs: "9.5px",
                  md: "1.5vw",
                  lg: "20px",
                }}
                sx={{ marginLeft: "5%" }}
              >
                Annual Rebate
              </Typography>
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                background: "#009A88",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTop: `1px ${theme.palette.secondary.light} solid`,
              }}
            >
              <img width="8%" src={tickMark} />
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: theme.palette.secondary.light,
              }}
            >
              <Typography
                sx={{ color: "#f22824" }}
                fontSize={{
                  xs: "2.5vw",
                  sm: "2.5vw",
                  md: "1.5vw",
                  lg: "1.5vw",
                }}
                variant="body2"
              >
                ?
              </Typography>
            </Box>
          </Box> */}
          {/* <Box
            width="100%"
            sx={{
              height: "calc(100% / 6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                borderRight: "none",
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                fontSize={{
                  xs: "9.5px",
                  md: "1.5vw",
                  lg: "20px",
                }}
                sx={{ marginLeft: "5%" }}
              >
                Tenure-Based Rewards
              </Typography>
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                background: "#009A88",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTop: `1px ${theme.palette.secondary.light} solid`,
              }}
            >
              <img width="8%" src={tickMark} />
            </Box>
            <Box
              width="calc(100% / 3)"
              height="100%"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRight: "none",
              }}
            >
              <Typography
                sx={{ color: "#f22824" }}
                fontSize={{
                  xs: "2.5vw",
                  sm: "2.5vw",
                  md: "1.5vw",
                  lg: "1.5vw",
                }}
                variant="body2"
              >
                ?
              </Typography>
            </Box>
          </Box> */}
        </Box>

        <Box
          width="100%"
          sx={{
            height: "10%",
            borderRadius: "2vw 2vw 0 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <Box
            width="calc(100% / 3)"
            height="100%"
            sx={{
              borderRight: "none",
            }}
          ></Box>
          <Box
            width="calc(100% / 3)"
            sx={{
              background: "#009A88",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              borderRadius: "0 0 2vw 2vw",
              padding: "1% 0",
              borderTop: `1px ${theme.palette.secondary.light} solid`,
              marginTop: {
                xs: "10%",
                sm: "8%",
                md: "8%",
                lg: "6%",
                xl: "8%",
                xxl: "6%",
              },
            }}
          >
            <Typography
              fontSize={{ xs: "9.5px", md: "1.5vw", lg: "30px" }}
              sx={{ color: "#fff", fontWeight: "500", marginBottom: "4%" }}
              variant="body2"
            >
              $300 / year in value!
            </Typography>
            <Button
              sx={{ padding: "3% 18% 3% 18%" }}
              className={classes.button}
            >
              <Typography
                fontSize={{
                  xs: "9.5px",
                  md: "2.5vw",
                  lg: "30px",
                }}
                sx={{ lineHeight: "2vw", fontWeight: "bold" }}
              >
                <Link
                  underline="none"
                  href={Utils.getEnrollmentLink(
                    //cookies.ref_promo,
                    state.zipcode,
                    "SEOEIQ0001",
                    state.bluebonnet?.ProductId,
                    state.bluebonnet?.Pricing[0].Terms
                  )}
                  color="inherit"
                >
                  <b>UPGRADE MY PLAN</b>
                </Link>
              </Typography>
            </Button>
          </Box>
          <Box width="calc(100% / 3)" height="100%" sx={{}}></Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PlanComparision;

const useStyles = makeStyles((theme) => ({
  button: {
    transition: "all .1s ease-in-out",
    border: "3px solid #FFD27D",
    "&:hover": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      background: "transparent",
    },
  },
  "@keyframes scale": {
    "0%": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
    },
    "50%": {
      transform: "scale(1.03, 1.03)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
}));
